export const QueryParams = Object.freeze({
  ORGNISATION: "organisation",
  APP_LANGUAGE: "app_language",
});

export const UrlConstants = Object.freeze({
  BASE_URL: process.env.REACT_APP_BASE_URL,
  BASE_PATH_URL: process.env.REACT_APP_BASE_PATH_URL,
  ASSESSMENT: process.env.REACT_APP_ASSESSMENT,
  TOKEN: process.env.REACT_APP_TOKEN,
  DSN_SENTRY_URL: process.env.REACT_APP_DSN_SENTRY_URL,
});
